export default __webpack_public_path__ + "static/media/bucket.73d19a97.svg";